// Images
export const ACROSS_LOGO = require("../assets/images/AcrossLogo.png");
export const APB_ILLUSTRATION = require("../assets/images/APBLoginIllustration.png");
export const ACT_PLAN = require("../assets/images/ActivatePlan.png");
export const APB = require("../assets/images/AirtelPaymentBank.png");
export const APB_TRNSPRNT = require("../assets/images/ApbLogo.png");
export const BALLON_FLY = require("../assets/images/BallonFly.jpg");
export const HLPR_IMG = require("../assets/images/HelperImage.png");
export const IMEI_PICS = require("../assets/images/ImeiPics.jpg");
export const POINT_ICON = require("../assets/images/PointIcon.png");
export const SUCCESS_CHECK = require("../assets/images/SuccessCheck.png");
export const UPLOAD_VIDEO_BAR = require("../assets/images/UploadVideoBar.png");
export const AUTH_GRAPHICS = require("../assets/images/Graphics.jpg");
export const LOGIN_STICLKERS = require("../assets/images/LoginStickers.webp");
export const PROFILE = require("../assets/images/Profile.png");
export const NO_DATA_FOUND = require("../assets/images/NoDataFound.jpg");

// Video
export const ADLD_VIDEO = require("../assets/video/ADLD-APB-Video.mp4");
export const UPLOAD_INSTRUCTION_VIDEO = require("../assets/video/UploadInstructionsVideo.mp4");
